// Es un bug de Eslint que se doluciona en versiones mas actualizadas
/* eslint-disable no-shadow */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { Form, Row, Col, Button, Accordion, Card, Table } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { map, isEmpty, filter, get } from 'lodash';
import uuid from 'uuid/v1';
import TelemetryConnections from '../../../api/TelemetryConnections/TelemetryConnections';
import LoadButton from '../../atoms/LoadButton';
import ModalElement from '../../components/ModalElement';
import PaginationComponent from '../../components/Pagination';

let domainWithoutLastSlash = '';
const FeacturesFuctions = props => {
  const [indexJson, setIndexJson] = React.useState({});
  const [indexArray, setIndexArray] = React.useState([]);
  const [isRealTime, setIsRealTime] = React.useState(false);
  const [isBbox, setIsBbox] = React.useState(false);
  const [isFromTable, setIsFromTable] = React.useState(true);
  const [box, setBox] = React.useState('');
  const [fetaureid, setFeatureId] = React.useState('');
  const [filte, setFilte] = React.useState([]);
  const [element, setElement] = React.useState([]);
  const [limit, setLimit] = React.useState(1000);
  const [limitB, setLimitB] = React.useState(1000);
  const [schema, setSchema] = React.useState('');
  const [stringSearch, setStringSearch] = React.useState('?limit=1000');
  const [search, setSearch] = React.useState('');
  const [uniqueSchema, setUniqueSchema] = React.useState([]);
  const [bbox, setBbox] = React.useState([0, 0, 0, 0]);
  const [loading, setLoading] = React.useState(false);
  const [elementePage, setElementPage] = React.useState(15);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [simpleProp, setSiempleProp] = React.useState({});
  const [stateForm, setStateForm] = React.useState([]);
  const [stateCheck, setStateCheck] = React.useState([]);
  const [modalShow, setModalShow] = React.useState(false);
  const [cadenaFiltrada, setCadenaFiltrada] = React.useState([]);
  const [metadataLayer, setMetadataLayer] = React.useState({
    id: '',
    title: '',
    description: '',
    extent: {
      spatial: {
        crs: '',
        bbox: [0, 0, 0, 0]
      }
    },
    links: [{ href: '' }]
  });
  const [previewMapUrl, setPreviewMapUrl] = React.useState('');
  const inputDomain = React.useRef('');

  const loadIndex = async indexUrlFile => {
    domainWithoutLastSlash = indexUrlFile;
    if (indexUrlFile.charAt(indexUrlFile.length - 1) === '/') {
      domainWithoutLastSlash = indexUrlFile.substr(0, indexUrlFile.length - 1);
    }
    const response = await fetch(`${domainWithoutLastSlash}/collections.json`, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      referrerPolicy: 'no-referrer'
    });
    const data = await response.json();
    const ids = [...new Set(map(data.collections, item => item.id))];
    setIndexArray(ids);
    const unique = [
      ...new Set(
        map(data.collections, item => {
          const { id } = item;
          const schemaArray = id.split('.', 1);
          return schemaArray[0];
        })
      )
    ];
    setUniqueSchema(unique);
    setIndexJson(data.collections);
    setCurrentPage(1);
  };

  const redirectToLayerView = () => {
    // Bert.alert(confirmation, 'success');
    window.open('/layers/new', '_self');
  };
  const redirectToLayerViewTab = () => {
    window.open('/layers/new', '_blank');
  };

  const loadDataToSource = data => {
    localStorage.setItem('Metadata', JSON.stringify(data));
    redirectToLayerView(data);
  };
  const loadLocalStorage = (data, isModal) => {
    localStorage.setItem('Metadata', JSON.stringify(data));
    if (!isModal) {
      redirectToLayerViewTab();
    } else {
      setModalShow(true);
    }
  };

  const loadMetadataLayer = async (id, but) => {
    if (fetaureid !== id) {
      setBox('');
      setLimit(1000);
      setCadenaFiltrada('');
      setElement('');
      setStringSearch('?limit=1000');
      setSiempleProp();
      const response = await fetch(`${domainWithoutLastSlash}/collections/${id}.json`, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      });
      const data = await response.json();
      const unique = map(data.properties, value => {
        return {
          value: [],
          type: value.type,
          name: value.name
        };
      });
      const fillCheck = Array(unique.length).fill(true);

      if (isEmpty(data.extent.bbox)) {
        setBbox(data.extent.spatial.bbox);
      } else {
        setBbox(data.extent.bbox);
      }
      setStateCheck(fillCheck);
      setSiempleProp(unique);
      setMetadataLayer(data);
    }
    setFeatureId(id);
    const subtype = isRealTime ? 'realTime' : 'GeoJSON';
    const details = {
      url: `${domainWithoutLastSlash}/collections/${id}/items.json${stringSearch}`,
      subtype
    };
    setPreviewMapUrl(`${domainWithoutLastSlash}/collections/${id}/items.html${stringSearch}`);
    if (but === 'PUSH') {
      loadDataToSource(details);
    } else if (but === 'TAB') {
      details.isModal = false;
      loadLocalStorage(details, false);
    } else if (but === 'Modal') {
      details.isModal = true;
      loadLocalStorage(details, true);
    }
  };
  const changeElementPerPage = event => {
    const value = event.target.value.trim();
    setElementPage(value);
  };
  const handleOnChangeServerList = evt => {
    const domain = evt.target.value;
    setPreviewMapUrl('');
    loadIndex(domain);
  };

  const handleSearch = event => {
    event.persist();
    setSearch(event.target.value.trim());
    const searchRegex = new RegExp(event.target.value.trim(), 'i');
    const searchRegexSchema = new RegExp(schema, 'i');
    const filteredLayersSchema = filter(indexJson, layer => {
      const schemaArray = get(layer, 'id', '').split('.', 1);
      const schema = searchRegexSchema.test(schemaArray[0]);
      return schema;
    });
    const filteredLayers = filter(filteredLayersSchema, layer =>
      searchRegex.test(get(layer, 'id', '').split('.', 1))
    );
    const ids = [...new Set(map(filteredLayers, item => item.id))];
    setIndexArray(ids);
  };

  const handleSchema = event => {
    event.persist();
    setSchema(event.target.value.trim());
    const searchRegex = new RegExp(search, 'i');
    const searchRegexSchema = new RegExp(event.target.value.trim(), 'i');
    const filteredLayersSchema = filter(indexJson, layer => {
      const schemaArray = get(layer, 'id', '').split('.', 1);
      const schema = searchRegexSchema.test(schemaArray[0]);
      return schema;
    });
    const filteredLayers = filter(filteredLayersSchema, layer =>
      searchRegex.test(get(layer, 'id', ''))
    );
    const ids = [...new Set(map(filteredLayers, item => item.id))];
    setIndexArray(ids);
  };

  const changeFilter = (event, name, id, index) => {
    const fill = Array(simpleProp.length).fill('-');
    const value = event.target.value.trim();
    const string = `&${name}=${value}`;

    if (!isEmpty(value)) {
      setCadenaFiltrada(string);
    } else {
      setCadenaFiltrada('');
    }

    fill[index] = value;

    setStateForm(fill);
  };

  const LoadPropertie = async id => {
    setLoading(true);
    const response = await fetch(
      `${domainWithoutLastSlash}/collections/${id}/items.json?limit=${limit}`,
      {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'no-referrer'
      }
    );
    const data = await response.json();
    const { properties } = metadataLayer;
    const propertiesJson = map(data.features, item => {
      return item.properties;
    });
    const unique = map(properties, value => {
      return {
        value: [...new Set(map(propertiesJson, item => item[value.name]))],
        type: value.type,
        name: value.name
      };
    });
    const fill = Array(unique.length).fill('');
    setStateForm(fill);

    setSiempleProp(unique);
    setLoading(false);
  };

  const changeFilterType = event => {
    const newState = simpleProp.map((value, index) => {
      if (event.target.id === value.name) {
        return !stateCheck[index];
      }
      return stateCheck[index];
    });
    const properties = simpleProp.map((value, index) => {
      if (newState[index]) {
        return value.name;
      }
      return null;
    });
    const newArr = properties.filter(a => a);
    setElement(`&properties=${newArr.join()}`);
    setStateCheck(newState);
  };
  const changeAll = event => {
    const check = event.target.checked;
    let newState = [];
    if (check) {
      newState = new Array(stateCheck.length).fill(true);
      setStateCheck(newState);
      setElement('');
    } else {
      newState = new Array(stateCheck.length).fill(false);
      setStateCheck(newState);
      setElement('');
    }
  };
  const selectBbox = () => {
    const arr = metadataLayer.extent.spatial.bbox;
    if (isBbox === false) {
      setBox(`&bbox=${arr.join()}`);
    } else {
      setBox('');
    }
    setIsBbox(!isBbox);
  };
  const updateUrls = () => {
    const str = `?limit=${limit}${box}${element}${cadenaFiltrada}`;
    setStringSearch(str);
    const UrlHtml = `items.html${str}`;
    if (!isEmpty(fetaureid)) {
      setPreviewMapUrl(`${domainWithoutLastSlash}/collections/${fetaureid}/${UrlHtml}`);
    }
  };
  const updateUrlImput = () => {
    if (!isEmpty(fetaureid)) {
      setPreviewMapUrl(
        `${domainWithoutLastSlash}/collections/${fetaureid}/items.html${stringSearch}`
      );
    }
  };
  const retoreFilter = () => {
    if (!isFromTable) {
      setBox('');
      setLimit(1000);
      setCadenaFiltrada('');
      setElement('');
      setStringSearch('?limit=1000');
    }
    setIsBbox(false);
    setIsFromTable(!isFromTable);
    const fill = Array(stateForm.length).fill('');
    setStateForm(fill);
    const newState = new Array(stateCheck.length).fill(true);
    setStateCheck(newState);
  };

  React.useEffect(() => {}, [metadataLayer]);
  React.useEffect(() => {
    updateUrls();
  }, [limit, element, cadenaFiltrada, box]);
  React.useEffect(() => {
    updateUrlImput();
  }, [stringSearch]);

  const { gmsConnections } = props;
  return (
    <>
      <Row>
        <Col xs={6}>
          <div className="row">
            <div className="col-12">
              <h4>Feature Functions</h4>
              <Form.Group>
                <Form.Control
                  as="select"
                  name="gmsConnection"
                  onChange={event => handleOnChangeServerList(event)}
                >
                  <option value="">-</option>
                  {map(gmsConnections, ({ _id, name, serverType, domain }) => {
                    if (serverType === 'DFS')
                      return (
                        <option value={domain} key={_id}>
                          {name}
                        </option>
                      );
                    return '';
                  })}
                </Form.Control>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-10">
              <Form.Control
                ref={inputDomain}
                name="DTL-URL"
                defaultValue="Database Tile Server URL"
              />
            </div>
            <div className="col-2">
              <Button
                block
                onClick={() => {
                  loadIndex(inputDomain.current.value);
                }}
              >
                Load URL
              </Button>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-12">
              <Row className="m-1" xs={12}>
                <iframe
                  title="Preview Map"
                  className="embed-responsive-item"
                  src={previewMapUrl}
                  style={{
                    display: 'block',
                    border: 'none',
                    width: '100vw',
                    height: `calc(85vh - 116px)`
                  }}
                />
              </Row>
            </div>
          </div>
        </Col>
        {isEmpty(indexJson) ? (
          false
        ) : (
          <Col xs={6}>
            <Row>
              <Col xs={4} className="flex-row align-items-center">
                <Form.Control
                  as="select"
                  defaultValue={elementePage}
                  className="mr-sm-2"
                  id="Elements"
                  onChange={event => changeElementPerPage(event)}
                  custom
                >
                  <option value="10">10 Elements per page</option>
                  <option value="15">15 Elements per page</option>
                  <option value="20">20 Elements per page</option>
                  <option value="30">30 Elements per page</option>
                  <option value="60">60 Elements per page</option>
                </Form.Control>
              </Col>
              <Col xs={4} className="flex-row align-items-center">
                <div className="position-relative">
                  <FontAwesomeIcon
                    className="position-absolute"
                    style={{
                      left: '12px',
                      top: '10px'
                    }}
                    color="var(--gray-light)"
                    icon="search"
                  />
                  <Form.Control
                    type="text"
                    name="search"
                    className="pl-5"
                    placeholder="Search Layer"
                    onKeyUp={handleSearch}
                  />
                </div>
              </Col>
              <Col xs={4} className="flex-row align-items-center">
                <Form.Control
                  as="select"
                  defaultValue=""
                  className="mr-sm-2"
                  id="Schema"
                  onChange={event => handleSchema(event)}
                  custom
                >
                  <option value="">-</option>
                  {map(uniqueSchema, value => {
                    return (
                      <option value={value} key={value}>
                        {value}
                      </option>
                    );
                  })}
                </Form.Control>
              </Col>
            </Row>
            <PaginationComponent
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setFilte={setFilte}
              elementePage={elementePage}
              indexArray={indexArray}
              elementPaginttion={11}
            />
            <div className="col-12">
              <Accordion>
                {map(indexJson, ({ title, id }) => {
                  if (filte.includes(id)) {
                    return (
                      <Card padding="0px" key={id}>
                        <Card.Header className="py-0">
                          <Row className="align-items-center justify-content-center" xs={12}>
                            <Col sm={6} md={7} lg={8} xl={9}>
                              <Accordion.Toggle
                                as={Card}
                                className="py-0 border-0"
                                style={{ backgroundColor: 'transparent' }}
                                eventKey={id}
                                onClick={() => loadMetadataLayer(id, '')}
                              >
                                {title}
                              </Accordion.Toggle>
                            </Col>
                            <Col sm={6} md={5} lg={4} xl={3}>
                              <Card
                                className="py-0 border-0"
                                style={{ backgroundColor: 'transparent' }}
                              >
                                <div className="text-left">
                                  <Button
                                    variant="light"
                                    title="Open"
                                    onClick={() => loadMetadataLayer(id, 'PUSH')}
                                  >
                                    <FontAwesomeIcon icon="file-alt" size="lg" />
                                  </Button>
                                  <Button
                                    variant="light"
                                    title="New Tab"
                                    onClick={() => loadMetadataLayer(id, 'TAB')}
                                  >
                                    <FontAwesomeIcon icon={['fa', 'link']} size="sm" />
                                  </Button>
                                  <Button
                                    variant="light"
                                    title="Open Modal"
                                    onClick={() => loadMetadataLayer(id, 'Modal')}
                                  >
                                    <FontAwesomeIcon icon={['fa', 'expand-arrows-alt']} />
                                  </Button>
                                </div>
                              </Card>
                            </Col>
                          </Row>
                        </Card.Header>

                        <Accordion.Collapse eventKey={id}>
                          <Card.Body>
                            <Col xs={12}>
                              <h4>Tile Metadata</h4>
                              <div className="row">
                                <div className="col-6">
                                  <Row className="m-1" xs={12}>
                                    <p>ID: {metadataLayer.id}</p>
                                  </Row>
                                  <Row className="m-1" xs={12}>
                                    <p>Description: {metadataLayer.description}</p>
                                  </Row>
                                  <Row className="m-1" xs={12}>
                                    <p>
                                      Tile URL:{' '}
                                      <a
                                        href={metadataLayer.links[0].href}
                                        target="_blank"
                                        rel="noreferrer noopener"
                                      >
                                        <FontAwesomeIcon icon={['fa', 'link']} size="sm" /> Link
                                      </a>
                                    </p>
                                  </Row>
                                </div>
                                <div className="col-6">
                                  <Row className="m-1" xs={12}>
                                    <p>Bounds</p>
                                    <ul>
                                      <li>Xmin: {bbox[0]}</li>
                                      <li>ymin: {bbox[1]}</li>
                                      <li>Xmax: {bbox[2]}</li>
                                      <li>Ymax: {bbox[3]}</li>
                                    </ul>
                                  </Row>
                                  <div className="col-8">
                                    <Form.Check
                                      type="switch"
                                      id="BBOX"
                                      disabled={!isFromTable}
                                      key="Bbox"
                                      label="Establishing the Bbox"
                                      checked={isBbox}
                                      onChange={selectBbox}
                                    />
                                  </div>
                                </div>
                              </div>
                              <Form.Group as={Row}>
                                <Form.Label column sm={3}>
                                  Search Parameters
                                  <Form.Check
                                    type="switch"
                                    id="Imput"
                                    key="Imput"
                                    label={isFromTable ? ' From Properties' : 'From Imput Text'}
                                    checked={isFromTable}
                                    onChange={() => {
                                      retoreFilter();
                                    }}
                                  />
                                </Form.Label>
                                <Col sm={9}>
                                  <Form.Control
                                    type="text"
                                    as="textarea"
                                    disabled={isFromTable}
                                    value={stringSearch}
                                    rows={3}
                                    onChange={e => setStringSearch(e.target.value)}
                                    name="search"
                                  />
                                </Col>
                              </Form.Group>
                              <div className="row">
                                <div className="col-6">
                                  <Table striped size="sm">
                                    <tbody>
                                      <tr>
                                        <td className="bg-secondary text-white ">
                                          <Form.Check
                                            size="sm"
                                            disabled={!isFromTable}
                                            id="All"
                                            key={uuid()}
                                            onChange={e => changeAll(e)}
                                            custom
                                            defaultChecked={stateCheck.every(v => v === true)}
                                          />
                                        </td>
                                        <td className="bg-secondary text-white ">
                                          <h6>Name</h6>
                                        </td>
                                        <td className="bg-secondary text-white">
                                          <h6> Type </h6>
                                        </td>
                                        <td className="bg-secondary text-white">
                                          <h6> Values </h6>
                                        </td>
                                      </tr>

                                      {map(simpleProp, (item, index) => (
                                        <tr>
                                          <td>
                                            <Form.Check
                                              size="sm"
                                              id={item.name}
                                              disabled={!isFromTable}
                                              key={uuid()}
                                              onChange={event => changeFilterType(event)}
                                              custom
                                              defaultChecked={stateCheck[index]}
                                            />
                                          </td>
                                          <td>{item.name}</td>
                                          <td>{item.type}</td>
                                          <td>
                                            {!isEmpty(item.value) && (
                                              <Form.Control
                                                as="select"
                                                disabled={!isFromTable}
                                                size="sm"
                                                name="Props"
                                                value={stateForm[index]}
                                                onChange={event =>
                                                  changeFilter(event, item.name, id, index)
                                                }
                                              >
                                                <option value="">Choose</option>
                                                {map(item.value, prop => {
                                                  return (
                                                    <option value={prop} key={prop}>
                                                      {prop}
                                                    </option>
                                                  );
                                                })}
                                              </Form.Control>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </Table>
                                </div>
                                <div className="col-6">
                                  <Row>
                                    <div className="col-4">
                                      <LoadButton
                                        isLoading={loading}
                                        clickAction={() => {
                                          LoadPropertie(id);
                                        }}
                                      />
                                    </div>
                                    <div className="col-8">
                                      <Form.Check
                                        type="switch"
                                        id="RealTime"
                                        key="RealTime"
                                        label="RT GeoJson"
                                        checked={isRealTime}
                                        onChange={() => setIsRealTime(!isRealTime)}
                                      />

                                      <Form.Check
                                        type="switch"
                                        id="GeoJson"
                                        key="GeoJson"
                                        label=" GeoJson"
                                        checked={!isRealTime}
                                        onChange={() => setIsRealTime(!isRealTime)}
                                      />
                                    </div>
                                  </Row>
                                  <div className="row">
                                    <div className="col-4">
                                      <Button
                                        variant="success"
                                        block
                                        onClick={() => {
                                          setLimit(limitB);
                                        }}
                                      >
                                        Set Limit
                                      </Button>
                                    </div>
                                    <div className="col-8">
                                      <Form.Control
                                        type="number"
                                        disabled={!isFromTable}
                                        min={0}
                                        max={10000}
                                        defaultValue={limitB}
                                        onChange={e => setLimitB(e.target.value)}
                                        step={1}
                                        precision={2}
                                        name="Limit"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Card.Body>
                        </Accordion.Collapse>
                      </Card>
                    );
                  }
                  return false;
                })}
              </Accordion>
            </div>
          </Col>
        )}
      </Row>
      <ModalElement
        modalShow={modalShow}
        onHide={() => setModalShow(false)}
        Componet="New Layer"
        {...props}
      />
    </>
  );
  //  }
};

FeacturesFuctions.defaultProps = {
  gmsConnections: [],
  history: {}
};

FeacturesFuctions.propTypes = {
  gmsConnections: PropTypes.array,
  history: PropTypes.object
};
export default withTracker(() => {
  const gmsConnectionsSub = Meteor.isClient && Meteor.subscribe('gmsConnections');
  return {
    loading: !gmsConnectionsSub.ready(),
    gmsConnections: TelemetryConnections.find().fetch()
  };
})(FeacturesFuctions);
